import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLocation } from '@reach/router';
import { initializeAndTrack } from 'gatsby-plugin-gdpr-cookies';
import Cookies from 'js-cookie';
import 'reactjs-popup/dist/index.css';

// import CookieSettings from './Settings';
const CookieWrapper = styled.div`
        position: fixed;
    inset: 0px;
    display: flex;
    z-index: 999;
    pointer-events: auto;
    
`
const Popup = styled.div`
       padding: 1rem 2rem;
    position: relative;
    margin: 2rem auto;
    border-radius: 12px;
    width: 60%;
    background: white;
    overflow-y: scroll;
    box-shadow: -1px 1px 11px 0px #0000002b;
    pointer-events: auto;
`
const PopupTitle = styled.h1`
    
font-family: 'Babe Sans';
font-style: normal;
font-weight: 400;
font-size: 50px;
line-height: 110%;
letter-spacing: -0.045em;
color: #000000;
`
const PopupParagraph = styled.p`
    /* Regular/Normal/Regular */

font-family: 'Inter';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height: 24px;
margin-top:-1rem;
color: #090A0A;
`
const About = styled.span`
    font-family: 'Inter';
font-style: normal;
font-weight: 700;
font-size: 16px;
line-height: 24px;
flex:1;
/* or 150% */

text-decoration-line: underline;

/* Ink/Darkest */

color: #090A0A;
`
const Flex = styled.div`
    display:flex;
    flex-direction: column;
    gap:1rem;
    margin:2rem;
`
const ButtonFit = styled.div`
    width:100%;
    text-align:end;
`
const Deselect = styled.button`
    font-family: 'Babe Sans';
font-style: normal;
font-weight: 400;
background:0;
border:0;
cursor:pointer;
margin-top:1rem;
font-size: 16px;
line-height: 17px;
width: fit-content;
text-align: right;
text-decoration-line: underline;

/* Ink/Darkest */

color: #090A0A;
`
const Accept = styled.button`
    padding: 0px 24px;
background: black;

border:0;
cursor:pointer;
flex:1;
border-radius: 12px;
letter-spacing: -0.5px;
color: white;
font-family: 'Inter';
font-style: normal;
font-weight: 500;
font-size: 18px;
line-height: 48px;
`
const FlexConsent = styled.div`
    display: flex;
    flex-direction: row;
`
const Button = styled.button`
padding: 0px 24px;
background: #D8FFDE;
border:0;
cursor:pointer;
flex:1;
border-radius: 12px;
letter-spacing: -0.5px;
color: #000000;
font-family: 'Inter';
font-style: normal;
font-weight: 500;
font-size: 18px;
line-height: 48px;
`
const PopupIcon = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    gap:44px;
    span{
        width: 214px;
    font-family: 'Babe Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 36px;
    line-height: 47px;
    -webkit-letter-spacing: -0.045em;
    -moz-letter-spacing: -0.045em;
    -ms-letter-spacing: -0.045em;
    letter-spacing: -0.045em;
    color: #000000;
    }
`
const FlexedButtons = styled.div`
display:flex;
flex-direction: row;
gap:17px;
margin-top:1rem;
`
const CookieBanner = () => {
    const [showBanner, setShowBanner] = useState(false);
    const [showSettings, setShowSettings] = useState(false);
    const location = useLocation();

    // showSettings -> use this state property to open a configuration
    // window which may open up more information on the cookie(s) being applied

    useEffect(() => {
        setShowBanner(Cookies.get('gatsby-gdpr-responded') !== 'true');
    }, [])

    useEffect(() => {
        initTracking();
    }, [Cookies.get('gatsby-gdpr-responded')])

    const initTracking = () => {
        initializeAndTrack(location)
    }

    const handleAccept = () => {
        Cookies.set('gatsby-gdpr-google-analytics', true, { expires: 365 })
        handleCloseAll();
    }

    const handleDecline = () => {
        Cookies.remove('gatsby-gdpr-google-analytics');
        handleCloseAll();
    }

    const handleCloseAll = () => {
        setShowSettings(false);
        setShowBanner(false);

        Cookies.set('gatsby-gdpr-responded', true, { expires: 365 });
    }

    return (
     <CookieWrapper>
     <Popup>
        <PopupTitle>
        The website uses cookies
        </PopupTitle>
        <PopupParagraph>
        Some are used for statistical purposes and others are set up by third party services. By clicking ‘Accept all’, you accept the use of cookies.

        </PopupParagraph>
       <Flex>
       <About>About cookies</About>
       <ButtonFit>
       <Deselect>Deselect all</Deselect>
       </ButtonFit>
   
       </Flex>
        <Flex>
        <FlexConsent>
        <PopupIcon>
        <svg width="20" height="60" viewBox="0 0 35 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M32.8177 25.7776C35.1339 28.1161 35.1339 31.8839 32.8177 34.2224L9.73552 57.5257C7.56748 59.7145 4.03031 59.7145 1.86227 57.5257C-0.276732 55.3662 -0.276733 51.8866 1.86227 49.7271L17.2199 34.2224C19.5362 31.8839 19.5361 28.1161 17.2199 25.7776L1.86227 10.2729C-0.276736 8.11338 -0.276733 4.63383 1.86227 2.47434C4.03031 0.285529 7.56748 0.285527 9.73552 2.47434L32.8177 25.7776Z" fill="black"/>
</svg>
<span>Strictly necessary</span>
        </PopupIcon>
        Strictly necessary cookies help make a website navigable by activating basic functions such as page navigation and access to secure website areas. Without these cookies, the website would not be able to work properly.
        </FlexConsent>
        </Flex>
        <Flex>
        <FlexConsent>
        <PopupIcon>
        <svg width="20" height="60" viewBox="0 0 35 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M32.8177 25.7776C35.1339 28.1161 35.1339 31.8839 32.8177 34.2224L9.73552 57.5257C7.56748 59.7145 4.03031 59.7145 1.86227 57.5257C-0.276732 55.3662 -0.276733 51.8866 1.86227 49.7271L17.2199 34.2224C19.5362 31.8839 19.5361 28.1161 17.2199 25.7776L1.86227 10.2729C-0.276736 8.11338 -0.276733 4.63383 1.86227 2.47434C4.03031 0.285529 7.56748 0.285527 9.73552 2.47434L32.8177 25.7776Z" fill="black"/>
</svg>
<span>Functional</span>
        </PopupIcon>
        Functional cookies make it possible to save information that changes the way the website appears or acts. For instance your preferred language or region.
        </FlexConsent>
        </Flex>
        <Flex>
        <FlexConsent>
        <PopupIcon>
        <svg width="20" height="60" viewBox="0 0 35 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M32.8177 25.7776C35.1339 28.1161 35.1339 31.8839 32.8177 34.2224L9.73552 57.5257C7.56748 59.7145 4.03031 59.7145 1.86227 57.5257C-0.276732 55.3662 -0.276733 51.8866 1.86227 49.7271L17.2199 34.2224C19.5362 31.8839 19.5361 28.1161 17.2199 25.7776L1.86227 10.2729C-0.276736 8.11338 -0.276733 4.63383 1.86227 2.47434C4.03031 0.285529 7.56748 0.285527 9.73552 2.47434L32.8177 25.7776Z" fill="black"/>
</svg>
<span>Statistical</span>
        </PopupIcon>
        Statistical cookies help the website owner understand how visitors interact with the website by collecting and reporting information.
        </FlexConsent>
        </Flex>
        <Flex>
        <FlexConsent>
        <PopupIcon>
        <svg width="20" height="60" viewBox="0 0 35 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M32.8177 25.7776C35.1339 28.1161 35.1339 31.8839 32.8177 34.2224L9.73552 57.5257C7.56748 59.7145 4.03031 59.7145 1.86227 57.5257C-0.276732 55.3662 -0.276733 51.8866 1.86227 49.7271L17.2199 34.2224C19.5362 31.8839 19.5361 28.1161 17.2199 25.7776L1.86227 10.2729C-0.276736 8.11338 -0.276733 4.63383 1.86227 2.47434C4.03031 0.285529 7.56748 0.285527 9.73552 2.47434L32.8177 25.7776Z" fill="black"/>
</svg>
<span>Marketing</span>
        </PopupIcon>
        Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and interesting to the individual user and thus more valuable for publishers and third-party advertisers.

        </FlexConsent>
        </Flex>
        <FlexedButtons>
        <Button>Decline All</Button>
        <Button>Save settings</Button>
        <Accept>Accept All</Accept>
        </FlexedButtons>
     </Popup>
     </CookieWrapper>
    )
}

export default CookieBanner